__turbopack_context__.v({
  "card": "pqQDQG_card",
  "cards": "pqQDQG_cards",
  "content": "pqQDQG_content",
  "ctaSectionContainer": "pqQDQG_ctaSectionContainer",
  "description": "pqQDQG_description",
  "footer": "pqQDQG_footer",
  "title": "pqQDQG_title",
});
